import {get} from '../axios'

class Login {
  async login(param) {
      const res = await get('/Account/Login',param)
      return res
  }
}
export default new Login()